<h1 mat-dialog-title class="no-select">
	{{ 'scim-administration.groups.detail.title' | translate }}
</h1>
<div mat-dialog-content>
	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.groups.columns.displayName' | translate }}</strong>
		</label>
		<p>{{ group.displayName }}</p>
	</div>
	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.groups.detail.groupId' | translate }}</strong>
		</label>
		<p>{{ group.id }}</p>
	</div>
	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.groups.detail.externalId' | translate }}</strong>
		</label>
		<p>{{ group.externalId }}</p>
	</div>

	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.groups.detail.members' | translate }}</strong>
		</label>
	</div>

	@if (!hasMembers) {
		<div class="empty-state">
			<p>{{ 'scim-administration.groups.detail.noMembers' | translate }}</p>
		</div>
	}

	@if (isLoadingMembers) {
		<div style="padding: 12px 0">
			<img class="spinner" src="./assets/spinner2.gif" style="width: 24px; height: 24px" />
		</div>
	}

	@if (hasMembers && !isLoadingMembers) {
		<table style="width: 100%; border-collapse: collapse">
			<thead>
				<tr>
					<th style="text-align: left; padding: 8px 12px; border-bottom: 1px solid rgba(0, 0, 0, 0.12)">
						{{ 'scim-administration.groups.detail.memberId' | translate }}
					</th>
					<th style="text-align: left; padding: 8px 12px; border-bottom: 1px solid rgba(0, 0, 0, 0.12)">
						{{ 'scim-administration.groups.detail.memberName' | translate }}
					</th>
					<th style="text-align: center; padding: 8px 12px; border-bottom: 1px solid rgba(0, 0, 0, 0.12)"></th>
				</tr>
			</thead>
			<tbody>
				@for (member of resolvedMembers; track member.userId) {
					<tr>
						<td style="padding: 8px 12px; border-bottom: 1px solid rgba(0, 0, 0, 0.06)">
							{{ member.userId }}
						</td>
						<td style="padding: 8px 12px; border-bottom: 1px solid rgba(0, 0, 0, 0.06)">
							@if (member.userExists) {
								<span>{{ member.name }}</span>
							}
							@if (!member.userExists) {
								<span style="color: #db0e0e; font-style: italic">
									{{ 'scim-administration.groups.detail.userNotFound' | translate }}
								</span>
							}
						</td>
						<td style="padding: 4px 12px; border-bottom: 1px solid rgba(0, 0, 0, 0.06); text-align: center">
							<button mat-icon-button color="warn" [disabled]="isRemoving" (click)="removeMember(member)" [matTooltip]="'scim-administration.groups.detail.removeMember.button' | translate">
								<mat-icon>delete</mat-icon>
							</button>
						</td>
					</tr>
				}
			</tbody>
		</table>
	}
</div>
<div mat-dialog-actions>
	<button mat-flat-button color="primary" (click)="close()">
		{{ 'scim-administration.groups.detail.close' | translate }}
	</button>
</div>
